import { forwardRef, useRef, useImperativeHandle } from "react";
import SidebarUser from "../../pages/user-dashboard/components/Sidebar";
import DefaultLayout from "../Default";

const UserDashboardLayout = forwardRef(({ children }, ref) => {
  const layoutRef = useRef()

  useImperativeHandle(ref, () => ({
    getUserDetail: () => layoutRef.current.getUserDetail(),
    getDomDestinations: (region) => layoutRef.current.getDomDestinations(region),
    handleUpdateUser: (formData) => layoutRef.current.handleUpdateUser(formData),
  }))

  return (
    <>
      <DefaultLayout ref={layoutRef} noHero bgColor="bg-white">
        <section className="max-sm:mt-14 px-6 sm:px-10 lg:px-14">
          <div className="sm:flex">
            <SidebarUser />
            {children}
          </div>
        </section>
      </DefaultLayout>
    </>
  );
})

export default UserDashboardLayout